import { gsap } from "gsap/gsap-core";
import { CSSPlugin } from 'gsap/CSSPlugin';
import Hammer from "hammerjs";
import Util from "../utils/util.js";
gsap.registerPlugin(CSSPlugin);
class ModalWindow {
    constructor() {
        this.initModalWindow();
    }
    mobileCheck(){
        if(window.matchMedia('(min-width:'+ this.settings.desktop +')').matches){
            return false;
        }else{
            return true;
        }
    }
    initModalWindow(){
        let modalLinks = Util.$('.js-video-window__link');
        let galleryGroup = Util.$('.js-ig-group');
        let videoWidget = Util.$('.js-video-widget__link');
        let vertVid = Util.$('.js-vert-vid__item-link');
        let tag = document.createElement('script');
        tag.src = "https://www.youtube.com/player_api";
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        let mw = this;
        if(modalLinks.length > 0){
            modalLinks.forEach(function(el){
                let modal = Util.$('.js-drawer')[0];
                let modalLink = el;
                mw.bindModalVideoLink(modalLink, modal);
            });
        }
        if(galleryGroup.length > 0){
            galleryGroup.forEach(function(el){
                let modal = Util.$('.js-drawer')[0];
                mw.bindModalGallery(el, modal);
            });
        }
        if(videoWidget.length > 0){
            videoWidget.forEach(function(el){
                let modal = Util.$('.js-drawer')[0];
                mw.bindModalVideoWidget(el, modal);
            });
        }
        if(vertVid.length > 0){
            vertVid.forEach(function(el){
                let modal = Util.$('.js-drawer')[0];
                mw.bindModalVideoWidget(el, modal, true);
            });
        }
    }
    bindModalGallery(galleryGroup, modal){
        // Loop through links
        // Add data-gallery_order to each link
        // figure out prev and next in gallery
        // bind initial click to add info to drawer
        // function for drawer update

        let galleryLinks = Util.$('.js-ig-group__item-link', galleryGroup);
        let spot = 0;
        let modalClose = Util.$('.js-drawer__nav-back')[0];
        let loader = '<div class="lds-ripple"><div></div><div></div></div>';
        let page = Util.$('html');
        let mw = this;
        let galleryItems = mw.setGalleryItems(galleryLinks);
        let galleryNav = Util.$('.js-drawer__nav-paging')[0];
        galleryLinks.forEach(function(el){
            el.setAttribute('data-gallery_spot', spot);
            spot = spot + 1;
            el.addEventListener("click", function(ev){
                ev.preventDefault();
                let num = el.getAttribute('data-gallery_spot');
                mw.showImgModal(modal, galleryItems[num], galleryLinks, galleryItems, num);
            });
        });
        document.onkeydown = function(evt) {
            evt = evt || window.event;
            if (evt.keyCode == 27) {
                let drawerWrapper = Util.$('.js-drawer__wrapper', modal);
                page[0].classList.remove('drawer-open');
                gsap.to(modal, {duration: 1, x: "100%", onComplete: function(){
                    drawerWrapper[0].innerHTML = loader;
                    galleryNav.innerHTML = "";
                }});
            }
        };
        modalClose.addEventListener('click', function(){
            page[0].classList.remove('drawer-open');
            let drawerWrapper = Util.$('.js-drawer__wrapper', modal);
            gsap.to(modal, {duration: 1, x: "100%", onComplete: function(){
                drawerWrapper[0].innerHTML = loader;
                galleryNav.innerHTML = "";
            }});
        })
    }
    setGalleryItems(galleryLinks){
        let galleryItems = [];
        let spot = 0;
        let mw = this;
        galleryLinks.forEach(function(el){
            el.setAttribute('data-gallery_spot', spot);
            let itemInfo = {};
            itemInfo.itemUrl = el.getAttribute('href');
            itemInfo.itemTitle = el.getAttribute('data-img_title');
            itemInfo.itemDesc = el.getAttribute('data-img_desc');
            itemInfo.itemAttrPrimary = el.getAttribute('data-img_attr_primary');
            itemInfo.itemAttrSecondary = el.getAttribute('data-img_attr_secondary');
            galleryItems[spot] = itemInfo;
            spot = spot + 1;
        });
        return galleryItems;
    }
    showImgModal(modal, info, galleryLinks, galleryItems, num){
            let drawerWrapper = Util.$('.js-drawer__wrapper', modal);
            let mw = this;
            let page = Util.$('html');
            gsap.to(modal, {
                duration: 1, x: "0%", onComplete: function () {
                    page[0].classList.add('drawer-open');
                    let modalImg = new Image();
                    modalImg.addEventListener('load', function(){
                        drawerWrapper[0].innerHTML = mw.buildContent(info);
                        mw.buildNav(modal, info, galleryLinks, galleryItems, num);
                    });
                    modalImg.src = info.itemUrl;
                    page[0].classList.add('drawer-open');
                    //TODO: ADD NAVIGATION
                }
            });
    }
    swapImage(info, modal, num){
        let drawerWrapper = Util.$('.js-drawer__wrapper', modal);
        let mw = this;
        let newContent = mw.buildContent(info);
        

        drawerWrapper[0].innerHTML = newContent;
    }
    buildContent(info){
        let content = "";
        let contentStart = '<div class="drawer__img-container"><div class="drawer__img-container-wrapper">';
        let contentEnd = '</div></div>';
        content = contentStart + '<img class="drawer__img" src="'+ info.itemUrl + '"/>';
        if(info.itemTitle || info.itemDesc || info.itemAttrPrimary || info.itemAttrSecondary){
            content = content + '<div class="drawer__meta">';
            if(info.itemTitle){
                content = content+'<p class="drawer__title">' + info.itemTitle + '</p>';
            }
            if(info.itemDesc){
                content = content+'<p class="drawer__desc">' + info.itemDesc + '</p>';
            }
            if(info.itemAttrPrimary){
                content = content+'<p class="drawer__attr-primary">' + info.itemAttrPrimary + '</p>';
            }
            if(info.itemAttrSecondary){
                content = content+'<p class="drawer__attr-secondary">' + info.itemAttrSecondary + '</p>';
            }
            content = content + '</div>'
        }
        content = content + contentEnd;
        return content;
    }
    buildNav(modal, info, galleryLinks, galleryItems, num, beenBuilt){
        let navMarkup = '';
        let mw = this;
        let navMarkupStart = '<div class="drawer__pagination"><ul class="drawer__pagination-list">';
        let navMarkupEnd = '</ul></div>';
        let spot = 0;
        let galleryNav = Util.$('.js-drawer__nav-paging')[0];
        let navControls = Util.$('.js-drawer__nav-control', modal);
        navMarkup = navMarkup + navMarkupStart;
        galleryItems.forEach(function(){
            navMarkup = navMarkup + '<li class="drawer__pagination-list-item"><a href="' + spot + '" class="drawer__pagination-list-item-link js-drawer__pagination-list-item-link" >'+ spot + '</a></li>';
            spot = spot + 1; 
        });
        navMarkup = navMarkup + navMarkupEnd;
        galleryNav.innerHTML = navMarkup;

        let navLinks = Util.$('.js-drawer__pagination-list-item-link', modal);
        navLinks[num].classList.add('-active');
        // Load prev and next images
        this.loadPrevNextImgs(galleryItems, num);
        // add arrows and nav to top of modal
        // checking to see if they've been bound
        if(!navControls[0].classList.contains('-active')){
            let thisHammer = new Hammer(modal);
            thisHammer.on('swipe', function(ev){
                let navLinks = Util.$('.js-drawer__pagination-list-item-link', modal);
                let activeLink = Util.$('.js-drawer__pagination-list-item-link.-active', modal)[0];
                let activeNum = parseInt(activeLink.getAttribute('href'), 10);
                if(ev.deltaX > 0 ){
                    activeNum = activeNum - 1;
                }else{
                    activeNum = activeNum + 1;
                }
                if(activeNum >= 0 && activeNum <= (navLinks.length + 1)){
                    navLinks[activeNum].click();
                }                    
            })
            navControls.forEach(function(el){
                el.classList.add('-active');
                el.addEventListener('click', function(ev){
                    ev.preventDefault();
                    let navLinks = Util.$('.js-drawer__pagination-list-item-link', modal);
                    let activeLink = Util.$('.js-drawer__pagination-list-item-link.-active', modal)[0];
                    let activeNum = parseInt(activeLink.getAttribute('href'), 10);
                    if(el.classList.contains('-prev')){
                        activeNum = activeNum - 1;
                    }else{
                        activeNum = activeNum + 1;
                    }
                    navLinks[activeNum].click();
                });
                
            });
        }
        
        // Bind events
        navLinks.forEach(function(el){
            el.addEventListener('click', function(ev){
                ev.preventDefault();
                if(el.classList.contains('-active')){
                    return false;
                }else{
                    let currentLink = Util.$('.js-drawer__pagination-list-item-link.-active', modal)[0];
                    let newNum = parseInt(el.getAttribute('href'), 10);
                    let newImgInfo = galleryItems[newNum];
                    el.classList.add('-active');
                    currentLink.classList.remove('-active');
                    mw.swapImage(newImgInfo, modal, newNum);
                    mw.loadPrevNextImgs(galleryItems, newNum);
                }
            });
        });
    }
    loadPrevNextImgs(galleryItems, num){
        let prevImg = new Image();
        let nextImg = new Image();
        let nextNum = parseInt(num, 10) + 1;
        let prevNum = parseInt(num, 10) - 1;
        if(num < galleryItems.length){
            nextImg.src = galleryItems[nextNum]["itemUrl"];
        }
        if(num > 0){
            prevImg.src = galleryItems[prevNum]["itemUrl"];
        }
    }
    
    bindModalVideoLink(modalLink, modal){
        let mw = this;
        let player;
        let modalClose = Util.$('.js-drawer__nav-back')[0];
        let loader = '<div class="lds-ripple"><div></div><div></div></div>';
        let page = Util.$('html');
        let vidBtn = Util.$('.js-video-window__btn', modalLink)[0];
        let parentRect = modalLink.getBoundingClientRect(),
            elemRect = vidBtn.getBoundingClientRect(),
            offsetY = elemRect.top - parentRect.top,
            offsetX = elemRect.left;
        let clientX = offsetX;
        let clientY = offsetY;
        let slowX = offsetX;
        let slowY = offsetY;
        const lerp = (a, b, n) => {
            return (1 - n) * a + n * b;
        };
        modalLink.addEventListener("mouseenter", function(e){
            // slowX = e.clientX;
            // slowY = e.clientY;
            modalLink.classList.add('-hovered');
            vidBtn.classList.remove('-returned');
        });
        modalLink.addEventListener("mouseleave", function(e){
            // slowX = e.clientX;
            // slowY = e.clientY;
            modalLink.classList.remove('-hovered');
            vidBtn.classList.add('-returned');
        });
        modalLink.addEventListener("mousemove", e => {
            clientX = e.clientX;
            clientY = e.clientY;
            slowX = lerp(slowX, clientX, 0.8);
            slowY = lerp(slowY, clientY, 0.8);
            var render = function(){
                gsap.set(vidBtn, {
                    x: slowX,
                    y: slowY
                });
                requestAnimationFrame(render);
            }
            requestAnimationFrame(render);
        });

        document.onkeydown = function(evt) {
            evt = evt || window.event;
            if (evt.keyCode == 27) {
                let drawerWrapper = Util.$('.js-drawer__wrapper', modal);
                page[0].classList.remove('drawer-open');
                gsap.to(modal, {duration: 1, x: "100%", onComplete: function(){
                    drawerWrapper[0].innerHTML = loader;
                }});
            }
        };
        modalLink.addEventListener('click', function(ev){
            ev.preventDefault();
            let content = '<div class="drawer__vid-container"><div id="drawer-vid"></div></div>';
            let vidId =  modalLink.getAttribute("data-vid_id");
            let drawerWrapper = Util.$('.js-drawer__wrapper', modal);
            let vidTitle = modalLink.getAttribute('data-vid_title');
            let vidDesc = modalLink.getAttribute('data-vid_desc');
            let vidAttr1 = modalLink.getAttribute('data-vid_attr_primary');
            let vidAttr2 = modalLink.getAttribute('data-vid_attr_secondary');
            if(vidTitle){
                content = content+'<p class="drawer__title">' + vidTitle + '</p>';
            }
            if(vidDesc){
                content = content+'<p class="drawer__desc">' + vidDesc + '</p>';
            }
            if(vidAttr1){
                content = content+'<p class="drawer__attr-primary">' + vidAttr1 + '</p>';
            }
            if(vidAttr2){
                content = content+'<p class="drawer__attr-secondary">' + vidAttr2 + '</p>';
            }
            gsap.to(modal, {
                duration: 1, x: "0%", onComplete: function () {
                    page[0].classList.add('drawer-open');
                    drawerWrapper[0].innerHTML = content;
                    player = new YT.Player('drawer-vid', {
                        videoId: vidId,
                        height: '360',
                        width: '640',
                        playerVars: {
                            autoplay: '1',
                            controls: '1',
                            enablejsapi: '1',
                            loop: '0',
                            mute: '0',
                            playsinline: '1',
                            modestbranding: '0',
                            showinfo: '1',
                            fs: '1'
                        }
                    });
                    page[0].classList.add('drawer-open');
                }
            });
        });
        modalClose.addEventListener('click', function(){
            page[0].classList.remove('drawer-open');
            let drawerWrapper = Util.$('.js-drawer__wrapper', modal);
            gsap.to(modal, {duration: 1, x: "100%", onComplete: function(){
                drawerWrapper[0].innerHTML = loader;
            }});
        })
    }

    bindModalVideoWidget(modalLink, modal, portrait){
        // Modal Video contains one or more options
        let mw = this;
        let player;
        let modalClose = Util.$('.js-drawer__nav-back')[0];
        let loader = '<div class="lds-ripple"><div></div><div></div></div>';
        let page = Util.$('html');
        let vidBtn = Util.$('.js-video-window__btn', modalLink)[0];
        let youtubeIcon = '<svg width="31" height="22" viewBox="0 0 31 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.2385 3.37626C30.0626 2.72177 29.7177 2.12502 29.2385 1.6458C28.7593 1.16658 28.1625 0.821727 27.508 0.645791C25.1004 -0.0101314 15.4421 -0.0101318 15.4421 -0.0101318C15.4421 -0.0101318 5.78127 -0.0101335 3.37368 0.635619C2.71942 0.812024 2.12292 1.15704 1.64378 1.63619C1.16463 2.11533 0.819617 2.71183 0.643212 3.36609C1.63658e-06 5.77368 0 10.7999 0 10.7999C0 10.7999 1.63658e-06 15.8261 0.643212 18.2337C0.819617 18.8879 1.16463 19.4844 1.64378 19.9636C2.12292 20.4427 2.71942 20.7877 3.37368 20.9641C5.78381 21.6099 15.4421 21.6099 15.4421 21.6099C15.4421 21.6099 25.103 21.6099 27.508 20.9641C28.1613 20.7891 28.7572 20.4457 29.2363 19.9684C29.7155 19.4911 30.061 18.8964 30.2385 18.2438C30.8843 15.8362 30.8843 10.81 30.8843 10.81C30.8843 10.81 30.8843 5.78385 30.2385 3.37626ZM12.3532 15.4422V6.17791L20.3768 10.81L12.3532 15.4422Z" fill="white"/></svg>';
        let instagramIcon = '<svg width="22" height="22" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_60_143)"><path d="M8.49999 1.53138C10.7697 1.53138 11.0383 1.54016 11.9348 1.58098C12.7635 1.61877 13.2136 1.75711 13.5132 1.87352C13.8829 2.00962 14.2172 2.22697 14.4917 2.50953C14.7743 2.78399 14.9916 3.11837 15.1277 3.48802C15.2441 3.78764 15.3825 4.23774 15.4202 5.06642C15.4611 5.96291 15.4698 6.23149 15.4698 8.50124C15.4698 10.771 15.4611 11.0396 15.4202 11.9361C15.3825 12.7647 15.2441 13.2148 15.1277 13.5145C14.9861 13.8809 14.7695 14.2138 14.4917 14.4916C14.2139 14.7694 13.881 14.986 13.5146 15.1276C13.2149 15.244 12.7648 15.3824 11.9362 15.4201C11.04 15.461 10.7711 15.4697 8.50134 15.4697C6.2316 15.4697 5.96268 15.461 5.06652 15.4201C4.23785 15.3824 3.78775 15.244 3.48813 15.1276C3.11848 14.9915 2.7841 14.7742 2.50964 14.4916C2.22708 14.2171 2.00974 13.8828 1.87363 13.5131C1.75722 13.2135 1.61889 12.7634 1.5811 11.9347C1.54027 11.0382 1.5315 10.7696 1.5315 8.49989C1.5315 6.23014 1.54027 5.96156 1.5811 5.06507C1.61889 4.23639 1.75722 3.78629 1.87363 3.48667C2.00974 3.11702 2.22708 2.78264 2.50964 2.50818C2.7841 2.22562 3.11848 2.00827 3.48813 1.87217C3.78775 1.75576 4.23785 1.61742 5.06652 1.57963C5.96302 1.53881 6.2316 1.53003 8.50134 1.53003L8.49999 1.53138ZM8.50134 -0.00146484C6.19279 -0.00146484 5.9033 0.00832001 4.99668 0.0498213C4.09006 0.0913226 3.47261 0.236071 2.93275 0.445939C2.36543 0.659501 1.85145 0.994096 1.42656 1.42645C0.99421 1.85134 0.659615 2.36532 0.446054 2.93264C0.236186 3.4725 0.0924499 4.0913 0.0512861 4.9959C0.0101223 5.90049 0 6.19134 0 8.49989C0 10.8084 0.00978484 11.0979 0.0512861 12.0046C0.0927873 12.9112 0.236186 13.5273 0.446054 14.0671C0.659702 14.6342 0.994292 15.148 1.42656 15.5726C1.85131 16.0053 2.36532 16.34 2.93275 16.5535C3.47261 16.7637 4.09141 16.9074 4.99601 16.9486C5.9006 16.9898 6.19212 16.9999 8.50067 16.9999C10.8092 16.9999 11.0987 16.9901 12.0053 16.9486C12.9119 16.9071 13.5274 16.7637 14.0672 16.5535C14.6321 16.3353 15.1451 16.0013 15.5732 15.5731C16.0014 15.145 16.3354 14.632 16.5536 14.0671C16.7638 13.5273 16.9075 12.9085 16.9487 12.0039C16.9899 11.0993 17 10.8078 17 8.49921C17 6.19066 16.9902 5.90116 16.9487 4.99455C16.9072 4.08793 16.7638 3.4725 16.5536 2.93264C16.3402 2.36552 16.0057 1.85174 15.5734 1.42712C15.1486 0.994527 14.6346 0.659698 14.0672 0.445939C13.5274 0.236071 12.9086 0.0923348 12.004 0.0511709C11.0994 0.0100071 10.8085 -0.00011521 8.49999 -0.00011521L8.50134 -0.00146484Z" fill="white"/><path d="M8.49998 4C7.63672 4 6.79284 4.25599 6.07507 4.73559C5.35729 5.21519 4.79786 5.89687 4.4675 6.69441C4.13715 7.49196 4.05071 8.36956 4.21912 9.21623C4.38754 10.0629 4.80324 10.8406 5.41365 11.451C6.02407 12.0615 6.80179 12.4772 7.64846 12.6456C8.49513 12.814 9.37273 12.7276 10.1703 12.3972C10.9678 12.0668 11.6495 11.5074 12.1291 10.7896C12.6087 10.0719 12.8647 9.22798 12.8647 8.36472C12.8647 7.79152 12.7519 7.22393 12.5325 6.69436C12.3132 6.16479 11.9917 5.68361 11.5864 5.2783C11.1811 4.87299 10.6999 4.55149 10.1703 4.33215C9.64076 4.11282 9.07317 3.99996 8.49998 4ZM8.49998 11.199C7.93942 11.199 7.39145 11.0327 6.92536 10.7213C6.45927 10.4099 6.096 9.96722 5.88149 9.44933C5.66697 8.93145 5.61084 8.36158 5.7202 7.81179C5.82956 7.262 6.0995 6.75699 6.49587 6.36061C6.89224 5.96424 7.39726 5.6943 7.94704 5.58494C8.49683 5.47559 9.0667 5.53171 9.58459 5.74623C10.1025 5.96075 10.5451 6.32402 10.8566 6.7901C11.168 7.25619 11.3342 7.80416 11.3342 8.36472C11.3342 9.11641 11.0356 9.8373 10.5041 10.3688C9.97256 10.9003 9.25166 11.199 8.49998 11.199Z" fill="white"/><path d="M13.0374 4.98254C13.6008 4.98254 14.0574 4.52588 14.0574 3.96255C14.0574 3.39923 13.6008 2.94257 13.0374 2.94257C12.4741 2.94257 12.0175 3.39923 12.0175 3.96255C12.0175 4.52588 12.4741 4.98254 13.0374 4.98254Z" fill="white"/></g><defs><clipPath id="clip0_60_143"><rect width="17" height="17" fill="white"/></clipPath></defs></svg>';
        let waterMark = '<span class="drawer__social-links-text">@visitutah</span>'
        let social = '';
        //let social = '<div class="drawer__social-links"><span class="drawer__social-links-text">@visitutah</span><a href="https://www.youtube.com/VisitUtah" class="drawer__social-links-btn" target="_blank">' + youtubeIcon + '</a><a href="https://www.instagram.com/visitutah/?hl=en" class="drawer__social-links-btn" target="_blank">' + instagramIcon + '</a></div>'    

        document.onkeydown = function(evt) {
            evt = evt || window.event;
            if (evt.keyCode == 27) {
                let drawerWrapper = Util.$('.js-drawer__wrapper', modal);
                page[0].classList.remove('drawer-open');
                gsap.to(modal, {duration: 1, x: "100%", onComplete: function(){
                    drawerWrapper[0].innerHTML = loader;
                }});
            }
        };
        modalLink.addEventListener('click', function(ev){
            ev.preventDefault();
            let content = '<div class="drawer__vid-container"><div id="drawer-vid"></div></div>';
            let vidId =  modalLink.getAttribute("data-vid_id");
            let drawerWrapper = Util.$('.js-drawer__wrapper', modal);
            let vidTitle = modalLink.getAttribute('data-vid_title');
            let vidSeconds = parseInt(modalLink.getAttribute('data-video_duration'));
            let vidDesc = modalLink.getAttribute('data-vid_desc');
            let vidAttr1 = modalLink.getAttribute('data-vid_attr_primary');
            let vidAttr2 = modalLink.getAttribute('data-vid_attr_secondary');
            let relatedVids = modalLink.getAttribute('data-vid_related');
            let hasWaterMark = modalLink.getAttribute('data-vid_display_watermark');
            
            const buildRelated = function(vidList){
                let theList = vidList['items'];
                let setFirst = false;
                let count = 0;
                theList.forEach(function(el){
                    count = count + 1;
                    let vidId =  el["YoutubeId"];
                    let relatedList = Util.$('.js-drawer__thumb-nav-list', modal);
                    let vidTitle = el['Title'];
                    let imgCrop = "";
                    let vidDesc = el['Description'];
                    let orientation = el['DisplayType'];
                    let vidAttr1 = "";
                    if (orientation === "portrait"){
                        imgCrop = "?width=57&height=100&mode=crop";
                    }
                    if (orientation ==="landscape"){
                        imgCrop = "?width=190&height=100&mode=crop";
                    }
                    let vidImgUrl = el['Thumbnail'] + imgCrop;
                    if(count == 1){
                        vidAttr1 = el['Credit'];
                    }else{
                        vidAttr1 = 'Directed by: ' + el['Credit'];
                    }
                    let thisVidSeconds = el['VideoDuration'];
                    let theseMinutes = Math.floor(thisVidSeconds / 60);
                    let theseSeconds = thisVidSeconds % 60;
                    if(theseSeconds < 10){
                        theseSeconds = "0" + theseSeconds;
                    }
                    let time = theseMinutes + ":" + theseSeconds;
                    //let time = "0";
                    let markupStart = '<li class="drawer__thumb-nav-listitem">';
                    let markupEnd = '</li>';
                    let item = "";
                    
                    item = item + markupStart + '<a href="#" class="drawer__thumb-nav-item-link js-drawer__thumb-nav-item-link ';
                    if(!setFirst){
                        item = item + '-active';
                        setFirst = true;
                        if(portrait){
                            orientation = "portrait";
                        }
                    }
                    item = item + '" data-vid_id="' + vidId + '" data-vid_orientation="' + orientation + '" data-vid_title="' + vidTitle +  '" data-vid_desc="' + vidDesc +'" ';
                    if(vidAttr1){
                      item = item + 'data-vid_attr_primary="' + vidAttr1 + '" >';  
                    } 
                    item = item + '<div class="drawer__thumb-nav-item"><div class="drawer__thumb-nav-media"><img src="' + vidImgUrl + '" alt="" class="drawer__thumb-nav-img"><div class="drawer__thumb-nav-media-length">' + time + '</div></div><div class="drawer__thumb-nav-item-info"><p class="drawer__thumb-nav-item-title">' + vidTitle + '</p></div></div></a>' + markupEnd;
                    relatedList[0].insertAdjacentHTML('beforeend', item);
                    if(theList.length === count){
                        let newLinks = Util.$('.js-drawer__thumb-nav-item-link', relatedList[0]);
                        if(newLinks.length > 0){
                            newLinks.forEach(function(el){
                                el.addEventListener('click', function(ev){
                                    ev.preventDefault();
                                    newLinks.forEach(function(el){
                                        el.classList.remove('-active');
                                    });
                                    el.classList.add('-active');
                                    let newContent = '<div class="drawer__vid-container"><div id="drawer-vid"></div></div>';
                                    let newVidId =  el.getAttribute("data-vid_id");
                                    let drawerWrapper = Util.$('.js-drawer__wrapper', modal);
                                    let newVidTitle = el.getAttribute('data-vid_title');
                                    let newVidDesc = el.getAttribute('data-vid_desc');
                                    let newVidAttr1 = el.getAttribute('data-vid_attr_primary');
                                    let displayType = el.getAttribute('data-vid_orientation');
                                    let hasWaterMark = modalLink.getAttribute('data-vid_display_watermark');
                                    if(displayType==="portrait"){
                                        modal.classList.add('-portrait');
                                    }else{
                                        modal.classList.remove('-portrait');
                                    }
                                    if(newVidTitle){
                                        newContent = newContent+'<p class="drawer__title">' + newVidTitle + '</p>';
                                    }
                                    if(newVidDesc){
                                        newContent = newContent+'<p class="drawer__desc">' + newVidDesc + '</p>';
                                    }
                                    if(newVidAttr1){
                                        newContent = newContent+'<p class="drawer__attr-primary">' + newVidAttr1 + '</p>';
                                    }
                                    // if(hasWaterMark === "True"){
                                    //     social = '<div class="drawer__social-links">' + waterMark + '<a href="https://www.youtube.com/VisitUtah" class="drawer__social-links-btn" target="_blank">' + youtubeIcon + '</a><a href="https://www.instagram.com/visitutah/?hl=en" class="drawer__social-links-btn" target="_blank">' + instagramIcon + '</a></div>'
                                    // }else{
                                    //     social = '<div class="drawer__social-links"><a href="https://www.youtube.com/VisitUtah" class="drawer__social-links-btn" target="_blank">' + youtubeIcon + '</a><a href="https://www.instagram.com/visitutah/?hl=en" class="drawer__social-links-btn" target="_blank">' + instagramIcon + '</a></div>'
                                    // }
                                    social = '<div class="drawer__social-links">' + waterMark + '<a href="https://www.youtube.com/VisitUtah" class="drawer__social-links-btn" target="_blank">' + youtubeIcon + '</a><a href="https://www.instagram.com/visitutah/?hl=en" class="drawer__social-links-btn" target="_blank">' + instagramIcon + '</a></div>'
                                    newContent = newContent + social;
                                    drawerWrapper[0].innerHTML = newContent;
                                    player = new YT.Player('drawer-vid', {
                                        videoId: newVidId,
                                        height: '360',
                                        width: '640',
                                        playerVars: {
                                            autoplay: '1',
                                            controls: '1',
                                            enablejsapi: '1',
                                            loop: '0',
                                            mute: '0',
                                            playsinline: '1',
                                            modestbranding: '0',
                                            showinfo: '1',
                                            fs: '1'
                                        }
                                    });
                                });
                            });
                        }
                    }
                });
            };
            if(relatedVids){
                modal.classList.add('-has-related');
                let theVids = JSON.parse(relatedVids);
                let activeItem = {};
                let firstThumbUrl;
                if(portrait){
                    firstThumbUrl = Util.$('.js-vert-vid__media-img', modalLink)[0].getAttribute('src');           
                }else{
                    firstThumbUrl = Util.$('.js-video-widget__media', modalLink)[0].getAttribute('data-bg_img_url') + '?width=190&height=100&mode=crop';
                }
                
                activeItem["Thumbnail"] = firstThumbUrl;
                activeItem["Title"] = vidTitle;
                activeItem["YoutubeId"] = vidId;
                activeItem["VideoDuration"] = vidSeconds;
                activeItem["Description"] = vidDesc;
                activeItem["Credit"] = vidAttr1;
                theVids['items'].splice(theVids, 0, activeItem);
                buildRelated(theVids);
            }
            if(portrait){
                modal.classList.add('-portrait');
            }
            if(vidTitle){
                content = content+'<p class="drawer__title">' + vidTitle + '</p>';
            }
            if(vidDesc){
                content = content+'<p class="drawer__desc">' + vidDesc + '</p>';
            }
            if(vidAttr1){
                content = content+'<p class="drawer__attr-primary">' + vidAttr1 + '</p>';
            }
            if(vidAttr2){
                content = content+'<p class="drawer__attr-secondary">' + vidAttr2 + '</p>';
            }
            // if(hasWaterMark === "True"){
            //     social = '<div class="drawer__social-links">' + waterMark + '<a href="https://www.youtube.com/VisitUtah" class="drawer__social-links-btn" target="_blank">' + youtubeIcon + '</a><a href="https://www.instagram.com/visitutah/?hl=en" class="drawer__social-links-btn" target="_blank">' + instagramIcon + '</a></div>'
            // }else{
            //     social = '<div class="drawer__social-links"><a href="https://www.youtube.com/VisitUtah" class="drawer__social-links-btn" target="_blank">' + youtubeIcon + '</a><a href="https://www.instagram.com/visitutah/?hl=en" class="drawer__social-links-btn" target="_blank">' + instagramIcon + '</a></div>'
            // }
            social = '<div class="drawer__social-links">' + waterMark + '<a href="https://www.youtube.com/VisitUtah" class="drawer__social-links-btn" target="_blank">' + youtubeIcon + '</a><a href="https://www.instagram.com/visitutah/?hl=en" class="drawer__social-links-btn" target="_blank">' + instagramIcon + '</a></div>'
            content = content + social;
            gsap.to(modal, {
                duration: 1, x: "0%", onComplete: function () {
                    page[0].classList.add('drawer-open');
                    drawerWrapper[0].innerHTML = content;
                    player = new YT.Player('drawer-vid', {
                        videoId: vidId,
                        height: '360',
                        width: '640',
                        playerVars: {
                            autoplay: '1',
                            controls: '1',
                            enablejsapi: '1',
                            loop: '0',
                            mute: '0',
                            playsinline: '1',
                            modestbranding: '0',
                            showinfo: '1',
                            fs: '1'
                        }
                    });
                    page[0].classList.add('drawer-open');
                }
            });
        });
        modalClose.addEventListener('click', function(){
            page[0].classList.remove('drawer-open');
            let drawerWrapper = Util.$('.js-drawer__wrapper', modal);
            let relatedVids = Util.$('.js-drawer__thumb-nav-list', modal);
            gsap.to(modal, {duration: 1, x: "100%", onComplete: function(){
                drawerWrapper[0].innerHTML = loader;
                relatedVids[0].innerHTML = "";
                modal.classList.remove('-has-related');
                modal.classList.remove('-portrait');
            }});
        })
    }

    showModal(modal){
        gsap.to(modal, {x: 0});
    }
    hideModal(modal){
        gsap.to(modal, {x: '100%'});
    }
}
export default ModalWindow;